import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted brand fonts (no Google Fonts network call) — handoffs/00-foundation.md A2.
// woff2 files ship in the bundle from src/styles/fonts via @font-face in fonts.css,
// so the fonts render reliably regardless of how @fontsource resolves at build time.
// Manrope = body/UI (400-800); Roboto Mono = numeric/eyebrow/footer/data-chip (400-600).
import './styles/fonts.css';
// Brand design tokens (CSS variables) — must load before index.css/app styles.
import './styles/tokens.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initFontScale } from './utils/fontScale';
import { initErrorReporting } from './utils/errorReporting';

// Apply the persisted UI text-size before first paint (handoffs/01-design-pass.md §4).
initFontScale();

// Relay uncaught errors to Cloud Error Reporting via the analytics server
// (see utils/errorReporting.js) — incident detection for the SPA.
initErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
